import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

@Directive()
export abstract class PrPeaFormBuilder extends PrFormAbstract {
  isAutomaticFlux: boolean;
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    this.isAutomaticFlux = entity.subLabel?.includes('via EUODIA');

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [entity ? entity.type : null, Validators.required],
        //product: [entity ? entity.label : null, Validators.required],
        owners: [this.buildInitialOwners(entity), Validators.required],
        purchasePrice: [
          entity ? entity.purchasePrice : null,
          Validators.required,
        ],
        lastValue: [entity ? entity.lastValue : null],
        startDate: [entity ? entity.startDate : null, Validators.required],
        subscriptionSource: [
          entity?.subscriptionSource ? entity.subscriptionSource : 'BANK',
          Validators.required,
        ],
        accountId: [entity ? entity.accountId : null, Validators.required],
        userId: [entity ? entity.userId : null, Validators.required],
        subscriptionId: [entity ? entity.subscriptionId : null],
        monthlyPayment: [entity ? entity.monthlyPayment : null],
        contratId: [entity ? entity.contratId : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      owners: this.form.value.owners,
      label: !this.isAutomaticFlux
        ? this.emptyIsNull(
            this.form.value.contratId.name
              ? this.form.value.contratId.name
              : this.form.value.contratId,
          )
        : undefined,
      purchasePrice: this.emptyIsNull(this.form.value.purchasePrice),
      lastValue: this.emptyIsNull(this.form.value.lastValue),
      startDate:
        new Date(this.form.value.startDate).toISOString().split('.')[0] + 'Z',
      subscriptionSource: this.emptyIsNull(this.form.value.subscriptionSource),
      accountId: this.emptyIsNull(this.form.value.accountId),
      userId: this.emptyIsNull(this.form.value.userId),
      subscriptionId: this.emptyIsNull(this.form.value.subscriptionId),
      monthlyPayment: this.emptyIsNull(this.form.value.monthlyPayment),
      //productId: !this.isAutomaticFlux ? this.emptyIsNull(this.form.value.product.id) : undefined,
      contratId: this.emptyIsNull(
        this.form.value.contratId.name
          ? this.form.value.contratId.name
          : this.form.value.contratId,
      ),
      status: 'STARTED',
      current: true,
    };
    return dto;
  }
}
